import { ActionType, CustomMetricsAction } from './actions'
import { CustomMetricsState } from './model'
import { CustomMetricsService } from './util/CustomMetricsService'

export const metricListInitialState = {
  metrics: undefined,
  isLoading: true
}

export const initialState: CustomMetricsState = {
  metricList: metricListInitialState
}

const reducer = (state: CustomMetricsState = initialState, action: CustomMetricsAction): CustomMetricsState => {
  switch (action.type) {
    case ActionType.FetchCustomMetrics:
      return {...state, metricList: metricListInitialState}

    case ActionType.FetchedCustomMetrics:
      const fetchedMetricList = {metrics: action.payload.metrics, isLoading: false}

      return {...state, metricList: fetchedMetricList}

    case ActionType.FetchAggregations:
      return CustomMetricsService.aggregationsLoading({...state}, action.payload.metric)

    case ActionType.FetchedAggregations:
      return CustomMetricsService.fetchedAggregations({...state}, action.payload.metric, action.payload.aggregations, action.payload.appId)

    case ActionType.AggregationChanged:
      return {...state,
        metricList: {
          ...state.metricList,
          metrics: CustomMetricsService.selectAggregationInState({...state}, action.payload.selectedAggregation, action.payload.metric)
        }
      }

    case ActionType.FetchMeasures:
      return CustomMetricsService.measuresLoading({...state}, action.payload.metric)

    case ActionType.FetchedMeasures:
      return CustomMetricsService.fetchedMeasures({...state}, action.payload.metric, action.payload.measures, action.payload.appId)

    case ActionType.MeasureChanged:
      return CustomMetricsService.selectMeasureInState({...state}, action.payload.selectedMeasure, action.payload.metric)

    case ActionType.FetchDimensions:
      return CustomMetricsService.dimensionsLoading({...state}, action.payload.metric)

    case ActionType.FetchedDimensions:
      return CustomMetricsService.fetchedDimensions({...state}, action.payload.metric, action.payload.dimensions, action.payload.appId)

    case ActionType.DimensionChanged:
      return CustomMetricsService.selectDimensionInState({...state}, action.payload.selectedDimension, action.payload.metric)

    default:
      return state
  }
}

export default reducer
